import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "form-outline mb-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "uploadName"
}, "Date", -1)
const _hoisted_3 = { class: "form-outline mb-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "uploadName"
}, "Description (optional)", -1)
const _hoisted_5 = ["disabled"]

import ModalDialog from "@/components/Modals/ModalDialog.vue";
import { useDataStore } from "@/store/data-store";
import { reactive } from "vue";
import Datepicker from "@vuepic/vue-datepicker";


export default /*#__PURE__*/_defineComponent({
  __name: 'NewSurveyDialog',
  props: {
	projectuuid: {
		type: String,
		required: true
	},
	isFirstSurvey:{
		type: Boolean,
		default: false
	},
},
  emits: ["onHide"],
  setup(__props, { expose, emit }) {

const props = __props;

const dataStore = useDataStore();



let data = reactive({
	description: null as string,
	date: new Date(),
	show: false
})



function show() {
	data.show = true;
}

async function create() {
	const survey = await dataStore.createSurvey(props.projectuuid, data.date, data.description);
	console.log("Create survey result", survey);
	data.show = false;
	emit("onHide", survey);
}

function hide() {
	data.show = false;
	emit("onHide");
}

expose({
	show
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalDialog, {
    visible: _unref(data).show,
    title: _unref(props).isFirstSurvey ? 'Create first survey' : 'Create new survey',
    onOnClose: _cache[2] || (_cache[2] = ($event: any) => (hide()))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createVNode(_unref(Datepicker), {
            modelValue: _unref(data).date,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(data).date) = $event)),
            "auto-apply": true,
            dark: true
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _withDirectives(_createElementVNode("input", {
            name: "uploadName",
            type: "text",
            class: "form-control",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(data).description) = $event))
          }, null, 512), [
            [_vModelText, _unref(data).description]
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            disabled: !_unref(data).date,
            class: "btn",
            onClick: create
          }, "Create", 8, _hoisted_5)
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible", "title"]))
}
}

})